import { MenuItem, Skeleton } from '@mui/material'
import CustomMuiSelect from 'Theme/Select'

export const GameFilter = ({ games, filters, handleAdd }) =>
  !!games.length ? (
    <CustomMuiSelect
      fullWidth
      value={filters['game']?.name || 'default'}
    >
      <MenuItem
        value="default"
        disabled
      >
        Select Game
      </MenuItem>
      {games.map((game) => (
        <MenuItem
          key={game.id}
          value={game.name}
          onClick={() => handleAdd('game', game, true)}
        >
          {game.name}
        </MenuItem>
      ))}
    </CustomMuiSelect>
  ) : (
    <Skeleton
      height={40}
      variant="primary"
    />
  )
